import { render } from "./FeMathsReport.vue?vue&type=template&id=dc509a28"
import script from "./FeMathsReport.vue?vue&type=script&lang=js"
export * from "./FeMathsReport.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3567143958/src/application/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__